import PaymentHistory from "../../../Components/Admin/MemberDetail/PaymentHistory/PaymentHistory";
import Violations from "../../../Components/Admin/MemberDetail/Violations/Violations";
import { getViolationsByMemberId } from "../../../Redux/Violation/ViolationActions";
import MyProfile from "../../../Components/Admin/MemberDetail/MyProfile/MyProfile";
import { getProfileById } from "../../../Redux/Profile/ProfileActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import React, { useEffect, useState } from "react";
import styles from "./MemberDetail.module.scss";
import { Link, useParams } from "react-router";

function MemberDetail() {
  const [activeTab, setActiveTab] = useState("myProfile");
  const dispatch = useDispatch<AppDispatch>();
  const { profileByIdLoading } = useSelector(
    (state: RootState) => state.profile,
  );
  const { violationsByMemberIdLoading } = useSelector(
    (state: RootState) => state.violations,
  );
  const { id } = useParams<{ id: string }>();

  const tabs = [
    {
      label: "My Profile",
      value: "myProfile",
    },
    {
      label: "Payment History",
      value: "paymentHistory",
    },
    {
      label: "Violations",
      value: "violations",
    },
  ];
  const tabsRenderer = () => {
    return (
      <React.Fragment>
        <div className={styles.tabsContainer}>
          {tabs.map((tab, i) => (
            <div
              key={i}
              className={
                activeTab === tab.value ? styles.activeTab : styles.tab
              }
              onClick={() => setActiveTab(tab.value)}
            >
              <p>{tab.label}</p>
            </div>
          ))}
        </div>
        <div className={styles.tabContent}>
          {activeTab === "myProfile" && <MyProfile />}
          {activeTab === "paymentHistory" && <PaymentHistory />}
          {activeTab === "violations" && <Violations />}
        </div>
      </React.Fragment>
    );
  };

  useEffect(() => {
    dispatch(getProfileById({ memberId: Number(id) }));
    dispatch(getViolationsByMemberId({ memberId: Number(id) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (profileByIdLoading || violationsByMemberIdLoading) {
    return <Loading />;
  }

  return (
    <div className={styles.mainContainer}>
      <Link to="/admin/members" replace className={styles.backButtonContainer}>
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Members
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Profile</p>
      </div>
      <div className={styles.bodyContainer}>
        <div className={styles.tabsContainer}>{tabsRenderer()}</div>
      </div>
    </div>
  );
}

export default MemberDetail;
